import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { useSettings } from "../../lib/settings";

export const SourcingNotice = ({ division, compact = false, testid = "sourcing-notice" }) => {
  const s = useSettings();
  return (
    <div className={`relative border border-[rgba(212,175,55,0.3)] bg-[radial-gradient(ellipse_at_top_left,rgba(212,175,55,0.1),transparent_60%)] ${compact ? "p-6" : "p-8 md:p-12"}`} data-testid={testid}>
      <Compass className="w-7 h-7 text-gold mb-5" />
      <p className="eyebrow mb-3">{division ? `${division.name} · Sourcing on request` : "Sourcing on request"}</p>
      <p className={`font-display text-slate-50 leading-snug max-w-2xl ${compact ? "text-xl" : "text-2xl md:text-3xl"}`}>{s.sourcing_message}</p>
      <Link to={`/sourcing${division ? `?division=${division.key}` : ""}`} className="btn-gold mt-7" data-testid={`${testid}-cta`}>
        Request an Asset <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};
